<template>
  <v-btn
    v-bind="activatorProps"
    :icon="iconName"
    size="30"
    :text="title"
    class="ma-1"
    variant="outlined"
    @click="isActive = true"
  ></v-btn>

  <v-dialog max-width="900" v-model="isActive">
    <v-card :title="title">
      <v-sheet class="mx-auto" width="300">
        <v-form @submit.prevent enctype="multipart/form-data" ref="form">
          <v-text-field
            v-model="formData.name"
            :rules="nameRules"
            label="الاسم"
          ></v-text-field>
          <v-text-field
            v-model="formData.phone"
            :rules="phoneRules"
            label="الجوال"
          ></v-text-field>
          <v-text-field
            v-model="formData.address"
            :rules="addressRules"
            label="العنوان"
          ></v-text-field>
          <v-text-field
            type="number"
            v-model="formData.balance"
            :rules="balanceRules"
            label="الرصيد"
          ></v-text-field>
        </v-form>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="حفظ" @click="save"></v-btn>

        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// import DialogMeter from "@/components/dialogs/DialogMeter.vue";
export default {
  components: {
    // DialogMeter,
  },
  props: ["saveFunction", "item", "mode", "iconName"],
  data() {
    return {
      isActive: false,
      formData: {
        name: "",
        phone: "",
        address: "",
        balance: 0,
      },
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 50) || "Name must be less than 10 characters",
      ],
      phoneRules: [(v) => !!v || "Phone is required"],
      addressRules: [(v) => !!v || "Address is required"],
      balanceRules: [(v) => !!v || "balance is required"],
      //balanceRules: [(v) => (!!v && v >= 0) || "Balance should be positive"],
    };
  },
  methods: {
    async validate() {
      const { valid } = await this.$refs.form.validate();

      if (valid) alert("Form is valid");
    },
    reset() {
      this.$refs.form.reset();
    },
    async save() {
      const { valid } = await this.$refs.form.validate();

      if (valid) {
        this.saveFunction(this.formData, this.mode);

        this.isActive = false;
      }
    },
    close() {
      this.isActive = false;
    },
  },
  watch: {
    isActive(value) {
      if (value) {
        console.log("cxcxC", this.item);
        if (this.mode == "edit") {
          this.formData = { ...this.item };
        }
      }
    },
  },
  computed: {
    title() {
      if (this.mode == "add") return "إضافة زبون";
      return "تعديل زبون";
    },
  },
};
</script>
